/**
 * Subcategory overview content is always mock/static.
 * Articles and media tabs load from the API when the user has access.
 */
import { getSubcategoryRichModule } from "../pages/guest_pages/subcategory_pages/registry";
import { getTopicExperience } from "../data/mockContentData";
import { getSubcategoryImage, patchRichDataImages, getIndustryGalleryImages } from "../data/subcategoryImages";

const DEFAULT_STATS = [
  { value: "3+", label: "Guides Available" },
  { value: "24h", label: "Expert Response" },
  { value: "5K+", label: "Readers Helped" },
];

function localizeExperience(experience, industryId, slug) {
  const primary = getSubcategoryImage(industryId, slug);
  const gallery = getIndustryGalleryImages(industryId);

  return {
    ...experience,
    cmsNote: undefined,
    heroImage: primary || experience.heroImage,
    gallery: [
      primary || gallery[0],
      gallery[1] ?? gallery[0],
      gallery[2] ?? gallery[0],
    ],
    stats: experience.stats?.length ? experience.stats : DEFAULT_STATS,
  };
}

/**
 * Returns mock overview payload for any subcategory page.
 * Never merges API/CMS payloads — overview stays static for now.
 */
export function buildSubcategoryOverview({ industryId, slug, menuItem, summary }) {
  const richModule = getSubcategoryRichModule(slug);

  if (richModule) {
    const raw = richModule.getDefaultData();
    const data = patchRichDataImages(raw, industryId, slug);
    return {
      mode: "rich",
      data,
      OverviewView: richModule.Views?.overview ?? null,
      heroImage: data.heroImage,
      stats: Array.isArray(data.stats) && data.stats.length ? data.stats : DEFAULT_STATS,
    };
  }

  const experience = localizeExperience(
    getTopicExperience(industryId, {
      name: menuItem.label,
      slug,
      description: menuItem.description,
      id: Number(String(menuItem.id).split("-").pop()) || 1,
    }),
    industryId,
    slug,
  );

  return {
    mode: "generic",
    experience,
    summary,
    heroImage: experience.heroImage,
    stats: experience.stats,
  };
}
